export default __webpack_public_path__ + "media/images/28-d5835a2a652bdfc335a6f73949991eea.jpg";